import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import {HttpParams} from '@angular/common/http';
import { AuthService } from '../../core/auth.service';
import { BaseService } from '../../shared/base.service';
import { UsersService } from '../../users/users.service';
import { HomeService } from '../home.service';
import { AppService } from '../../app.service';
import { UserModel } from '../../users/user.model';
import { HomeComponent } from '../home.component';
import { ClinicsService } from '../../clinics/clinics.service';
import { UsersComponent } from '../../users/users.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'clinic-admin-component',
    templateUrl: './clinic-admin.component.html',
    styleUrls: ['../home.component.scss'],
    providers: [UsersService, BaseService, HomeService, ClinicsService]
})

export class ClinicAdminComponent extends HomeComponent implements OnInit {

    @ViewChild('usersComponent', { static: false }) usersComponent: UsersComponent;

    clinicUsers: Object[] = [];

    /**
     *
     * @param authService
     * @param router
     * @param translate
     * @param baseService
     * @param appService
     * @param usersService
     * @param homeService
     */
    constructor(public authService: AuthService,
                public router: Router,
                public translate: TranslateService,
                public baseService: BaseService,
                public appService: AppService,
                public usersService: UsersService,
                public homeService: HomeService) {
        super(authService, router, translate, baseService, appService, usersService);
    }

    /**
     * Component Init
     */
    ngOnInit() {
        super.ngOnInit();
        this.searchInfo = new UserModel();
        this.url = 'home';
    }

    /**
     * Handle search result dropdown
     * @param event
     */
    typeaheadOnSelect(event) {
        const user = event.item;

        if (user.hasOwnProperty('keyword')) {
            this.searchInfo.keyword = user.keyword;
            this.searchItems();
        } else {
            const deactivateMessage = 'Are you sure you want to deactivate this user account?';
            const activeMessage = 'Are you sure you want to activate this user account?';
            const message = user['activated'] ? deactivateMessage : activeMessage;

            const urlSearchParams = new HttpParams();
            urlSearchParams.append('action', 'read');
            urlSearchParams.append('id', user['id']);
            urlSearchParams.append('title', 'User Details');
            urlSearchParams.append('activated', user['activated']);
            urlSearchParams.append('content', message);
            urlSearchParams.append('description', user['email']);
            urlSearchParams.append('role-id', user['role_id']);
            const body = urlSearchParams.toString();
            const fullPopupUrl = '/users?' + body;

            this.searchInfo.keyword = '';
            this.isLoading = true;

            this.router.navigateByUrl(fullPopupUrl);
        }
    }

    handleAddUser() {
        this.usersComponent.openFormModal({action: 'create', title: 'Add User', url: '/home'});
    }

    handleEditClinic() {
        this.usersComponent.openClinicFormModal({
            action: 'update',
            id: this.authService.user.clinic_id,
            title: 'Update Clinic',
            url: 'home',
            component: 'clinics'
        });
    }

    /**
     * @param e
     */
    exportUser(e) {
        this.token = this.authService.user['token'];
        e.target.blur();
        e.target.parentElement.blur();
        window.location.href = this.authService.baseUrl + 'retrieve-data/users/' + this.user['clinic'].id + '?token=' + this.token;
    }
}
